import { AddIcon, Button, DeleteIcon, IconButton, TextField } from "@firecms/ui";

import type { QueryRow } from "../types";

type Props = {
  rows: QueryRow[];
  onChange: (next: QueryRow[]) => void;
  suggestedKeys?: string[];
};

export const QueryRowsInput = ({ rows, onChange, suggestedKeys }: Props) => {
  const datalistId = suggestedKeys?.length
    ? `query-suggestions-${suggestedKeys.join("-")}`
    : undefined;

  const update = (index: number, patch: Partial<QueryRow>) =>
    onChange(rows.map((r, i) => (i === index ? { ...r, ...patch } : r)));

  const remove = (index: number) => onChange(rows.filter((_, i) => i !== index));

  const add = () => onChange([...rows, { key: "", value: "" }]);

  return (
    <div className="flex flex-col gap-2">
      {rows.map((row, index) => (
        <div key={index} className="flex items-center gap-2">
          <TextField
            size="small"
            placeholder="key"
            value={row.key}
            onChange={(e) => update(index, { key: e.target.value })}
            className="flex-1"
            list={datalistId}
          />
          <span className="text-text-secondary dark:text-text-secondary-dark text-sm">=</span>
          <TextField
            size="small"
            placeholder="value"
            value={row.value}
            onChange={(e) => update(index, { value: e.target.value })}
            className="flex-1"
          />
          <IconButton size="small" onClick={() => remove(index)}>
            <DeleteIcon size="small" />
          </IconButton>
        </div>
      ))}
      <div>
        <Button variant="text" size="small" startIcon={<AddIcon size="small" />} onClick={add}>
          Add filter
        </Button>
      </div>
      {datalistId && (
        <datalist id={datalistId}>
          {suggestedKeys!.map((k) => (
            <option key={k} value={k} />
          ))}
        </datalist>
      )}
    </div>
  );
};
